import React from 'react';
import { Modal, Button, Menu, Icon, Input, Checkbox, Popconfirm, Dropdown, Divider } from 'antd';
import moment from 'moment';
const CheckboxGroup = Checkbox.Group;

class ModalSchoolAdmin extends React.Component {

  constructor() {
    super();
    this.state = {
      first: '',
      last: '',
      email: '',
      id: '',
      school: [],
      schoolid: []
    }
  }


  updateData = () => {
    if (this.props.mode == 'edit') {
      this.setState({
        first: this.props.data.first,
        last: this.props.data.last,
        email: this.props.data.email,
        school: this.props.data.school,
        schoolid: this.props.data.schoolid,
        id: this.props.data.id
      })
    }
  }

  cancel = () => {
    this.setState({
      first: '',
      last: '',
      email: '',
      school: []
    }, () => { this.props.cancel() }
    )
  }

  save = () => {

    let data = {}
    data = {
      id: this.state.id,
      first: this.state.first,
      last: this.state.last,
      email: this.state.email,
      school: this.state.school,
      schoolid: this.state.schoolId
    }
    this.props.save(data, this.props.mode)
  }

  schoolDropdown = () => {
    if (this.props.allschools) {
      //Filter already used schools
      let schools = Object.entries(this.props.allschools)
      return (
        <Menu onClick={(e) => this.setState({ school: e.item.props.children, schoolId: e.key })}>
          {schools.map(school =>
            <Menu.Item key={school[1][0]}>{school[1][1].name}</Menu.Item>
          )}
        </Menu>
      )
    } else {
      return (
        <Menu onClick={(e) => this.setState({ school: e.item.props.children, schoolId: e.key })}>
          <Menu.Item key="1">Loading...</Menu.Item>
        </Menu>
      )
    }
  }

  render() {
    const t = this.props.t

    return (
      <div>
        <Modal
          className="edituser"
          visible={this.props.open}
          onOk={this.save}
          onCancel={this.cancel}
        >
          <h3 style={heading}>{t('First name')}</h3>
          <Input
            style={input}
            onChange={(e) => this.setState({ first: e.target.value })}
            value={this.state.first}
          />
          <h3 style={heading}>{t('Last name')}</h3>
          <Input
            style={input}
            onChange={(e) => this.setState({ last: e.target.value })}
            value={this.state.last}
          />
          <h3 style={heading}>{t('Email')}</h3>
          {this.props.mode == 'edit' ?
            <p>{this.state.email}</p>
            :
            <input
              style={input}
              onChange={(e) => this.setState({ email: e.target.value })}
              value={this.state.email}
            />
          }
          <h3 style={heading}>{t('School')}</h3>

          {this.props.data && this.props.mode == 'edit' ?
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                <Dropdown overlay={this.schoolDropdown()}>
                  <Button>
                    {this.state.school} <Icon type="down" />
                  </Button>
                </Dropdown>
              </div>
            </div>

            :
            <Dropdown overlay={this.schoolDropdown()}>
              <Button>
                {this.state.school} <Icon type="down" />
              </Button>
            </Dropdown>
          }
        </Modal>
      </div>
    )
  }
}
const buttonStyle = {
  width: '300px'
}
const input = {
  width: '300px',
  borderBottom: '2px solid #F4F3F4',
  borderRadius: '0px'
}
const heading = {
  fontSize: '18px',
  marginTop: '20px'
}

export default ModalSchoolAdmin;



// WEBPACK FOOTER //
// ./src/components/ModalSchoolAdmin/index.jsx